import { Controller } from "@api/config";

import type { IGalleryItemsRequest } from "./request.types";
import type { TGalleryItemsResponse } from "./response.types";

class GalleryController extends Controller {
	public constructor() {
		super({ requestUrl: "models/gallery/" });
	}

	/** @GET VR video history items */
	public async getItemsAsync({ token, params }: IGalleryItemsRequest) {
		return this.get<TGalleryItemsResponse>("base", "items", { token, params });
	}
}

export const galleryAPI = new GalleryController();
